import { SupportCardProps } from "@/components/screen/global-components/support/SupportCard";
import * as images from "@/components/images/Images_second";

const affiliateSupportCards: SupportCardProps[] = [
  {
    title: "Affiliate Program",
    description:
      "Refer new clients using an affiliate link and receive a commission. Reach out to learn more and get your tracking link.",
    imageUrl: images.provide1,
    href: "/support",
    linkLabel: "Contact us",
  },
  {
    title: "White labeled services",
    description:
      "Offer a white-labeled custom-branded version of Languex for your clients. Reach out to learn more.",
    imageUrl: images.provide2,
    linkLabel: "Learn more",
  },
  {
    title: "Business account",
    description:
      "Establish a business account to access volume-based discounted project pricing and resell our translation services to your clients. ",
    imageUrl: images.provide3,
    linkLabel: "Learn more",
  },
];

export const affiliateSupportData = {
  title: "What business services does Languex provide?",
  description: null,
  cards: affiliateSupportCards,
};
